import React from 'react';
import ModuleDetailTable from './moduleDetailTable/ModuleDetailTable';

const ConfigModule = () => {
  return (
    <section>
      <ModuleDetailTable />
    </section>
  );
};

export default ConfigModule;
